import { Box, Heading, HStack, Stack, VStack } from "@chakra-ui/react";
import Sticky from "react-stickynode";

import { EnsoSwapWidget, EnsoSwapWidgetProps } from "./EnsoSwapWidget";
import { OtherDexInfo } from "./OtherDexInfo";
import { PlumeAssetsInfo } from "./PlumeAssetsInfo";

import { PageLayout } from "@/components/page-layout";
import { MAX_PAGE_WIDTH, plumeMainnetId } from "@/constants/shared";

export const Swap = () => {
  const bridgeProps: EnsoSwapWidgetProps = {
    chainId: plumeMainnetId,
    initialTokenInAddress: "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee",
  };

  return (
    <PageLayout>
      <Box
        pb={[8, 8, "60px"]}
        background={`url('/assets/bridge/swap-hero.svg') no-repeat center center`}
        backgroundSize="cover"
        mx={["-2", "-2", "-6"]}
        width={["calc(100% + 16px)", "calc(100% + 16px)", "calc(100% + 48px)"]}
        px={[2, 2, 6]}
        mt={[-14, -14, -16]}
        pt={8}
      >
        <HStack gap={3} pb={[8, 8, "76px"]} maxW={MAX_PAGE_WIDTH} mx="auto">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
          >
            <rect
              x="1.5"
              y="1.5"
              width="29"
              height="29"
              rx="10.5"
              fill="#0C0D0F"
            />
            <rect
              x="1.5"
              y="1.5"
              width="29"
              height="29"
              rx="10.5"
              stroke="url(#paint0_linear_10266_16957)"
              strokeWidth="3"
            />
            <path
              d="M19.0511 13.412V18.5167L17.0472 16.4962V11.3914L19.0511 13.412Z"
              fill="white"
            />
            <path
              d="M13.4643 19.048H18.5244L16.5215 17.0264H11.4614L13.4643 19.048Z"
              fill="white"
            />
            <path
              d="M8.88889 8.88995L8.88889 14.5438L10.8928 16.5643L10.8928 10.9105L16.4785 10.9294L14.4756 8.90779L8.88995 8.88892"
              fill="white"
            />
            <path
              d="M21.8992 16.2852L19.8953 14.2647V19.9185L14.3096 19.8997L16.3124 21.9212L21.3213 21.9344L22.429 23.0128L23.1111 23.1111L22.9812 22.4557L21.8992 21.3491V16.2852Z"
              fill="white"
            />
            <defs>
              <linearGradient
                id="paint0_linear_10266_16957"
                x1="16"
                y1="0"
                x2="16"
                y2="32"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="white" stopOpacity="0.12" />
                <stop offset="1" stopColor="white" stopOpacity="0" />
              </linearGradient>
            </defs>
          </svg>
          <Heading
            fontSize="xl"
            fontWeight="700"
            lineHeight="28px"
            letterSpacing="-0.47px"
          >
            Swap
          </Heading>
        </HStack>
        <VStack
          gap={4}
          alignItems="flex-start"
          maxW={["100%", "100%", MAX_PAGE_WIDTH]}
          mx="auto"
        >
          <Heading
            fontSize="40px"
            lineHeight="48px"
            fontWeight="700"
            letterSpacing="-0.8px"
          >
            Swap Assets
          </Heading>
          <Heading
            fontSize="xl"
            fontWeight="500"
            letterSpacing="-0.47px"
            lineHeight="28px"
            color="text.secondary"
            maxW={["100%", "100%", "50%"]}
          >
            Effortlessly trade your assets on Plume with low-slippage and
            real-time pricing
          </Heading>
        </VStack>
        <Box hideFrom="md" mt={5}>
          <EnsoSwapWidget {...bridgeProps} />
        </Box>
      </Box>
      <Stack
        mt={2}
        flexDirection={["column", "column", "row"]}
        gap={[6, 6, 16]}
        w="full"
        maxW={MAX_PAGE_WIDTH}
        mx="auto"
      >
        <VStack w="full" gap={[6, 6, 10]}>
          <PlumeAssetsInfo />
          <OtherDexInfo />
        </VStack>
        <Box
          mt={[0, 0, "-140px"]}
          hideBelow="md"
          minW={["100%", "100%", "400px"]}
        >
          <Sticky top={16}>
            <EnsoSwapWidget {...bridgeProps} />
          </Sticky>
        </Box>
      </Stack>
    </PageLayout>
  );
};
